export enum TOURS_ACTION_TYPES {
  FETCH_TOURS_START = "tours/FETCH_TOURS_START",
  FETCH_TOURS_SUCCESS = "tours/FETCH_TOURS_SUCCESS",
  FETCH_TOURS_FAILED = "tours/FETCH_TOURS_FAILED",
  CLEAR_TOURS = "tours/CLEAR_TOURS",
}
